"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mesola": {
    "6e1b9eb5": [{
      "hkey": "1b22e440",
      "slug": "ariano-ferrarese",
      "name": "Ariano Ferrarese",
      "primary": true,
      "skipSearch": false
    }],
    "ariano": [{
      "hkey": "1b22e440",
      "slug": "ariano-ferrarese",
      "name": "Ariano Ferrarese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6b1a2b7d": [{
      "hkey": "52eda4f2",
      "slug": "bosco-mesola",
      "name": "Bosco Mesola",
      "primary": true,
      "skipSearch": false
    }],
    "bosco": [{
      "hkey": "52eda4f2",
      "slug": "bosco-mesola",
      "name": "Bosco Mesola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;